export function formataValorMonetario(value) {
  const sign = value < 0 ? '- ' : '';
  const newValue = Math.abs(value || 0);
  return sign + newValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
